import React from 'react';
import { Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import PubSub from 'pubsub-js';
import { action, computed, observable, reaction, makeObservable } from 'mobx';
import { ContentLookup, TimeZone, User, X4Unit, X5Lesson } from 'domain/index';
import {
    Control,
    ReactNodeGenerator,
    validators,
    Disposers
} from 'lib/helpers';
import { ClassroomEditFormStore } from './TeacherEditLessonModalStore';
import { ContentLookupStore } from 'scenes/schedule/administrator/parts/ContentLookupStore';
import {
    X4UnitSelect,
    X5LessonSelect
} from 'lib/components';
import { observer } from 'mobx-react';
import { environment } from 'lib/environment';
import { httpClient } from 'domain/utils/httpClient';


type Props = {
    onSaveSuccess: () => void,
}

type State = {
    isOpen: boolean;
}

export interface TeacherEditLessonModal_Data {
    classroomId: number,
    studentLevelId: number,
    unitId: number,
    lessonId: number,
}

@observer
export class TeacherEditLessonModal extends React.Component<Props, State> {
    state = {
        isOpen: false
    };

    private pubSubToken: string | null = null;

    private readonly contentLookup = new ContentLookupStore();

    @observable.ref
    private form: ClassroomEditFormStore | null = null;

    private classRoomId: number | null = null;
    private studentLevelId: number | null = 11;
    private readonly disposers = new Disposers();


    constructor(props: Props) {
        super(props);
        makeObservable(this);
    }


    onCloseClick() {
        this.setState({ isOpen: false });
    }

    onModalOpened() {

    }

    *renderLessonControls(): ReactNodeGenerator {
        if (this.studentLevelId === null) {
            return;
        }
        if (this.form == null) {
            return;
        }

        const { unitOptions, unit } = this.form;
        const { lessonOptions, lesson } = this.form;

        yield (
            <div key="select-unit">
                <div className={unit.formGroupClassName}>
                    <label>Unit</label>
                    <X4UnitSelect options={unitOptions}
                        value={unit.value}
                        onChange={unit.setValue}
                        onBlur={unit.markTouched} />
                    <div className="invalid-text"> Select unit</div>
                </div>
            </div>
        );

        yield (
            <div key="select-lesson">
                <div className={lesson.formGroupClassName}>
                    <label>Lesson</label>
                    <X5LessonSelect options={lessonOptions}
                        value={lesson.value}
                        onChange={lesson.setValue}
                        onBlur={lesson.markTouched} />
                    <div className="invalid-text"> Select lesson</div>
                </div>
            </div>
        );
    }

    async onSaveClick() {
        if (!this.form) {
            return;
        }
        const lessonId = this.form.lesson.value?.Id;
        const reqData = {
            ClassroomId: this.classRoomId,
            LessonId: lessonId
        }

        const url = `${environment.apiServer}/teacher/update-classroom-lesson`;
        await httpClient.axios.postWithSweetAlert(url, reqData);
        this.props.onSaveSuccess();
    }

    *renderer(): ReactNodeGenerator {
        const self = this;
        yield (
            <Modal isOpen={this.state.isOpen}
                size="lg"
                key="modal"
                centered
                onOpened={() => this.onModalOpened}>
                <ModalHeader>
                    <div>Change Lesson</div>
                </ModalHeader>
                <ModalBody>
                    {Array.from(this.renderLessonControls())}
                </ModalBody>
                <ModalFooter>
                    <button type="button" className="btn btn-primary"
                        onClick={() => self.onSaveClick()} value="test">Save
                    </button>
                    <button type="button" className="btn btn-primary"
                        onClick={() => self.onCloseClick()} value="test">Close
                    </button>
                </ModalFooter>
            </Modal>
        );
    }

    render() {
        return Array.from(this.renderer());
    }



    componentDidMount() {
        this.contentLookup.load();
        this.onContentLookupReady();
        this.disposers.add(reaction(() => this.contentLookup.lookupState?.isResolved, () => {
            if (this.contentLookup.lookupState == null) {
                return;
            }
            if (this.contentLookup.lookupState.isResolved === false) {
                return;
            }
            this.onContentLookupReady();
        }));
        this.pubSubToken = PubSub.subscribe("TeacherEditLessonModal_Open", this.mySubscriber);
    }

    onContentLookupReady() {
        if (this.contentLookup.lookupState?.isResolved !== true) {
            return;
        }

        this.form = new ClassroomEditFormStore(this.contentLookup.lookupState!.value.lookup);
    }

    componentWillUnmount() {
        if (this.pubSubToken) {
            PubSub.unsubscribe(this.pubSubToken);
        }
        this.disposers.dispose();
    }

    mySubscriber = (msg: any, data: any) => {
        const self = this;
        if (!self.form) {
            return;
        }
        const unitId: number = data.unitId;
        const lessonId: number = data.lessonId;
        if (!unitId || !lessonId) {
            return;
        }
        self.classRoomId = data.classroomId;
        self.studentLevelId = data.studentLevelId;
        self.form.studentLevelId = self.studentLevelId;
        self.form.setLesson(unitId, lessonId);
        self.setState({ isOpen: true });
    }
}